import { render, staticRenderFns } from "./InfoRequest.vue?vue&type=template&id=c576ddfc"
import script from "./InfoRequest?vue&type=script&lang=ts&external"
export * from "./InfoRequest?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports